// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1nB0X","sendOtp":"AuthorizeToLogin_sendOtp__D0BBW"};